'use strict';
angular.module('atex.dam').directive('damDatePicker', ['$translate', '$timeout', '$window', 'UIConfigurationService', function ($translate, $timeout, $window, UIConfigurationService) {
  var linker = function (scope, element, attrs) {
    UIConfigurationService.getSearchOptions().then(function (options) {
      var dateFormat = atex.onecms.ObjectUtils.getByPath(options, 'dateFormat') || "";
      var isTo = 'dateTo' in attrs;
      var format;
      if (dateFormat !== ""){
        format = dateFormat;
      }else{
        format = "DD/MM/YYYY";
      }
      function hasTime() {
        return format.toLowerCase().indexOf("h") > -1;
      }

      var parent = $('#date-wrapper');

      var defaultConfig = {
        widgetParent: parent,
        locale: $translate.use(),
        showClose: true,
        showTodayButton: true,
        format: format,
        useCurrent: false,
        timeZone: "UTC",

        icons: {
          time: 'fa fa-clock-o',
          date: 'fa fa-calendar',
          up: 'fa fa-chevron-up',
          down: 'fa fa-chevron-down',
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right',
          today: 'fa fa-calculator',
          clear: 'fa fa-trash',
          close: 'fa fa-times'
        }
      };

      var picker = element.datetimepicker(defaultConfig);
      var dt = picker.data("DateTimePicker");

      picker.on("dp.show", function () {
        var top = 0;
        var left = 0;

        var datepicker = $('.bootstrap-datetimepicker-widget:last');
        if (datepicker.hasClass('bottom')) {
          top = $(this).offset().top + $(this).outerHeight();
          left = $(this).offset().left - 34;
        } else if (datepicker.hasClass('top')) {
          top = $(this).offset().top - datepicker.outerHeight();
          left = $(this).offset().left - 32;
        }

        var windowSize = Number(angular.element($window).width());
        var position = Number(left) + Number(datepicker.width());

        if (position > windowSize) {
          left = left - (position - windowSize) - 30;
        }

        datepicker.css({
          position: "fixed",
          "z-index": 101001,
          top: top,
          left: left,
          bottom: "auto",
          right: "auto",
          "font-family": "sans-serif",
          "font-weight": "normal"
        });
      });

      scope.$on('dam:clearAdvancedFields', function () {
        if(scope.date) {
          dt.date(null);
          scope.date = "";
        }
      });

      picker.on('dp.change', function (e) {
        var currentDate = (e.date) ? e.date.startOf('day')._d : undefined;

        if (currentDate) {
          if (!scope.isTimestamp) {
            // The getTimezoneOffset() method returns the time difference between UTC time and local time, in minutes
            // For example, If your time zone is GMT+2, -120 will be returned.
            // Then we re arrange the DateTime to be the datetime at UTC
            //currentDate.setMinutes(currentDate.getMinutes() - currentDate.getTimezoneOffset());
          } else if (isTo && !hasTime()) {
            currentDate.setMilliseconds(currentDate.getMilliseconds() + (24 * 60 * 60 * 1000 - 1));
          }
        }

        $timeout(function () {
          if (currentDate) {
            scope.date = currentDate.toISOString();
          } else {
            scope.date = "";
          }

          if (scope.callBack) {
            scope.callBack();
          }
        });
      });

      scope.$watch(function () {
        return scope.date;
      }, function (newValue, oldValue) {
        if(!newValue) {
          return;
        }

        if (newValue && newValue !== '*') {
          var _date = new Date(newValue);
          if (!scope.isTimestamp) {
            //_date.setMinutes(_date.getMinutes() + _date.getTimezoneOffset());
          } else if (isTo && !hasTime()) {
            _date.setMilliseconds(_date.getMilliseconds() - (24 * 60 * 60 * 1000 - 1));
          }

          var m = moment(_date);
          if (m.isValid()) {
            dt.date(_date);
          }

        } else {
          dt.date(null);
        }
      });

    });


  };

  return {
    restrict: 'AE',
    scope: {
      date: "=",
      callBack: "&",
      isTimestamp: "="
    },
    link: linker
  };
}]);